import { render, staticRenderFns } from "./DuplicateFound.vue?vue&type=template&id=6bd243a8&"
import script from "./DuplicateFound.vue?vue&type=script&lang=js&"
export * from "./DuplicateFound.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateFound.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports